import type { EmptyObject } from 'type-fest';

import { nuc } from '../../utils';
import { get, post } from '../api';
import asyncTaskThunk from '../jobs/asyncTaskThunk';
import type { Task } from '../../../models/types';

export const actionTypes = Object.freeze({
  GET_REMEDIATION_GUIDANCE: 'GET_REMEDIATION_GUIDANCE',
  GET_NEXT_SAFE_VERSION: 'GET_NEXT_SAFE_VERSION',
  GET_NEXT_SAFE_VERSION_LIST: 'GET_NEXT_SAFE_VERSION_LIST',
  CREATE_ORG_SECURITY_REPORT: 'CREATE_ORG_SECURITY_REPORT',
});

/**
 * Action for V2 APIs, gets the complete and partial remediation guidance given a revision and vuln
 */
export const getRemediationGuidance = (revisionId: string, vulnId: string) => ({
  type: actionTypes.GET_REMEDIATION_GUIDANCE,
  payload: get(`/api/vulns/${nuc(vulnId)}/revisions/${nuc(revisionId)}/remediation-guidance`),
});

/**
 * Action for V1 APIs, gets the complete next safe version for a revision
 */
export const getNextSafeVersion = (revisionId: string) => ({
  type: actionTypes.GET_NEXT_SAFE_VERSION,
  payload: get(`/api/vulns/revision/${nuc(revisionId)}/next-safe-version`),
});

/**
 * Action for V1 APIs, gets the complete next safe version for a list of revision
 */
export const getNextSafeVersionList = (revisions: string[]) => ({
  type: actionTypes.GET_NEXT_SAFE_VERSION_LIST,
  payload: post(`/api/vulns/revisions/next-safe-version`, { revisions }),
});

/**
 * Action for requesting a global vulns report
 */
export const createOrgSecurityReport = () => asyncTaskThunk(() => ({
  type: actionTypes.CREATE_ORG_SECURITY_REPORT,
  async payload() {
    return post<EmptyObject, Task>(`/api/vulns/report/global`, {});
  },
}));
